<template>
  <section 
  id="as-section-market-research"
  class="as-section as-section--market-research"
  data-section="market-research">
    <div class="as-section__top">
      <h2 class="as-section__title">2018 Market Snapshot<template v-if="selectedCounty && selectedCounty.name"> - "{{ selectedCounty.name }}"</template></h2>
      <div class="as-section__top__background-layer" style="background-image: url(/img/patterns/binary-pattern.png);"></div>
      <!-- <div class="as-section__top__background-layer" style="background-image: url(/img/backgrounds/line-chart-illustration.png);"></div> -->
      
      <div class="as-section__large-stats">

        <!-- Average HPA -->
        <template v-if="agent && agent.agent_page && agent.agent_page.hpa_average && agent.agent_page.hpa_average !== 0">
          <div class="as-section__large-stat">
            <span class="as-section__large-stat__number">{{ parseFloat(agent.agent_page.hpa_average * 100).toFixed(2) }}%</span>
            <span class="as-section__large-stat__label">Average Home <br class="d-none d-md-block" />Price Appreciation</span>
            <a :href="`/research/county/${selectedCounty.slug}?activeMarketDataTab=home-price-appreciation`" class="btn--cta btn btn--cta--outline btn--cta--white btn--sm" target="_blank">
              <i class="fal fa-chart-line"></i>
              <span class="the-text">View Chart</span>
            </a>
            <span class="source oa-tool-tip" title="Source: SmartZip">
              <i class="fal fa-info-circle mr-1"></i>
              Source</span>
          </div>
        </template>
        

        <!-- Migrations -->
        <template v-if="agent && agent.agent_page && (agent.agent_page.inbound_migration && agent.agent_page.outbound_migration) && (agent.agent_page.inbound_migration !== 0 && agent.agent_page.outbound_migration !== 0)">
          <div class="as-section__large-stat">
            <span class="as-section__large-stat__number">{{ netMigrationsLabel }}</span>
            <span class="as-section__large-stat__label">Net Inbound/Outbound <br class="d-none d-md-block" />Migrations</span>
            <a :href="`/research/county/${selectedCounty.slug}?activeMarketDataTab=migration-patterns`" class="btn--cta btn btn--cta--outline btn--cta--white btn--sm" target="_blank">
              <i class="fal fa-chart-line"></i>
              <span class="the-text">View Chart</span>
            </a>
            <span class="source oa-tool-tip" title="Source: Internal Revenue Service">
              <i class="fal fa-info-circle mr-1"></i>
              Source</span>
          </div>
        </template>
        

        <!-- Unemployment -->
        <template v-if="agent && agent.agent_page && agent.agent_page.unemployment_rate && agent.agent_page.unemployment_rate !== 0">
          <div class="as-section__large-stat">
            <span class="as-section__large-stat__number">{{ parseFloat(agent.agent_page.unemployment_rate) }}%</span>
            <span class="as-section__large-stat__label">Unemployment <br class="d-none d-md-block" />Rate</span>
            <a :href="`/research/county/${selectedCounty.slug}?activeMarketDataTab=unemployment`" class="btn--cta btn btn--cta--outline btn--cta--white btn--sm" target="_blank">
              <i class="fal fa-chart-line"></i>
              <span class="the-text">View Chart</span>
            </a>
            <span class="source oa-tool-tip" title="Source: US Bureau of Labor">
              <i class="fal fa-info-circle mr-1"></i>
              Source</span>
          </div>
        </template>
        

        <!-- Total Population -->
        <template v-if="agent && agent.agent_page && agent.agent_page.total_population && agent.agent_page.total_population !== 0">
          <div class="as-section__large-stat">
            <span class="as-section__large-stat__number">{{ agent.agent_page.total_population | numberWithCommas }}</span>
            <span class="as-section__large-stat__label">Total <br class="d-none d-md-block" />Population</span>
            <a :href="`/research/county/${selectedCounty.slug}?activeMarketDataTab=population`" class="btn--cta btn btn--cta--outline btn--cta--white btn--sm" target="_blank">
              <i class="fal fa-chart-line"></i>
              <span class="the-text">View Chart</span>
            </a>
            <span class="source oa-tool-tip" title="Source: US Census">
              <i class="fal fa-info-circle mr-1"></i>
              Source</span>
          </div>
        </template>
        


        
      </div>
    </div>
    <template v-if="selectedCounty && selectedCounty.slug">
      <div class="as-section__bottom">
        <h3 class="as-section__sub-title">Looking for more data?</h3>
        <a :href="`/research/county/${selectedCounty.slug}`" class="btn btn--cta btn--cta--primary btn--cta--pill text-nowrap" target="_blank">
          <i class="fal fa-chart-line"></i>
          <span class="the-text">View Data Visualizations</span>
        </a>
      </div>
    </template>
  </section>
</template>

<script>
import WaypointMixin from '@vue/mixins/waypoint-mixin';
import { roundToDecimals } from '@vue/store/helpers';
export default {
  mixins: [
    WaypointMixin
  ],

  props: {
    selectedCounty: {
      id: '',
      slug: '',
    },
    agent: {},
  },

  computed: {
    netMigrationsLabel(){
      const sum = this.agent.agent_page.inbound_migration - this.agent.agent_page.outbound_migration;
      if(Math.abs(sum) > 1000){
        let result = (parseInt(sum) / 1000).toFixed(2);
        return result + 'k'
      } else {
        return sum;
      }
    },
    totalPopulation(){
      if(!this.agent || !this.agent.agent_page || !this.agent.agent_page.total_population) return false;
      let pop = this.agent.agent_page.total_population;
      if(pop > 1000000){
          return '$' + (parseFloat(pop / 1000000).toFixed(1)).toString() + 'm';
      } else {
          return '$' + (parseInt(pop / 1000)).toString() + 'k';
      }
    }
  },

  mounted() {
    this.$addObserver(this.$el, this.onWaypointEnter, this.intersectionOptions);
  }
}
</script>